import { Component, Input, SimpleChanges } from '@angular/core';
import { AccessRequestSocketService } from '@service/access-request-socket.service';
import { AuthService } from '@service/auth.service';
import { AccessRequest } from 'icreate/common/models/access-request';
import { Vessel } from 'icreate/common/models/vessel';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-guest-left-message',
    templateUrl: './guest-left-message.component.html',
    styleUrls: ['./guest-left-message.component.css'],
    standalone: false,
})
export class GuestLeftMessageComponent {
    @Input() vessel: Vessel;

    private destroySubscriptions$: Subject<void> = new Subject();

    guestLeftNames: any[] = [];

    constructor(
        private accessRequestSocketService: AccessRequestSocketService,
        private authService: AuthService
    ) {}

    async ngOnInit() {
        this.startSubscriptions();
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.vessel) {
            this.guestLeftNames = [];
        }
    }

    ngOnDestroy(): void {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    closeMessage(index) {
        this.guestLeftNames.splice(index, 1);
    }

    private startSubscriptions() {
        this.accessRequestSocketService
            .leftEditing$()
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe(async (accessRequest: AccessRequest) => {
                const currentUser = this.authService.getCurrentUser();
                if (accessRequest.vesselId === this.vessel.id && currentUser.oid === this.vessel.ownerOid) {
                    this.guestLeftNames.push(accessRequest.userName);
                }
            });
    }
}
